import { EnemyType, ENEMY_TYPES } from '@/levels/EnemyTypes';
import { EnemyWeights } from '@/levels/LevelData';

/** Picks an enemy type from weighted odds. `roll` is a random number in [0, 1). */
export function pickEnemyType(weights: EnemyWeights, roll: number): EnemyType {
  const entries = ENEMY_TYPES
    .map(type => [type, weights[type] ?? 0] as const)
    .filter(([, weight]) => weight > 0);

  const total = entries.reduce((sum, [, weight]) => sum + weight, 0);
  if (total <= 0) return 'standard';

  let threshold = roll * total;
  for (const [type, weight] of entries) {
    if (threshold < weight) return type;
    threshold -= weight;
  }
  return entries[entries.length - 1][0];
}

/**
 * A spawn point just outside the viewport. `edgeRoll` picks the edge
 * (top, right, bottom, left) and `positionRoll` the position along it.
 */
export function spawnPointOnEdge(
  width: number,
  height: number,
  margin: number,
  edgeRoll: number,
  positionRoll: number
): { x: number; y: number } {
  switch (Math.min(3, Math.floor(edgeRoll * 4))) {
    case 0: return { x: positionRoll * width, y: -margin };
    case 1: return { x: width + margin, y: positionRoll * height };
    case 2: return { x: positionRoll * width, y: height + margin };
    default: return { x: -margin, y: positionRoll * height };
  }
}
